var PopUp = function () {

    var $elements = {}

    var setElements = function () {
        $elements = {
            openBasePopup: $('.js-open-popup')
        }
    }

    var loadJS = function () {
        UL.getScriptCdn(
            '//cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js',
            config.bowerPath + 'magnific-popup/dist/jquery.magnific-popup.min.js',
            loadCSS
        );
    };

    var loadCSS = function () {
        UL.getScriptCdn(
            '//cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.min.css',
            config.bowerPath + 'magnific-popup/dist/magnific-popup.css',
            initPopup
        );
    };

    var preparedPopup = function () {
        if (typeof popupMessage !== "undefined") {
            $.magnificPopup.open({
                items: {
                    src: '<div class="o-popup">' + popupMessage + '</div>',
                    type: 'inline'
                }
            });
        }
    };

    var basePopup = function () {
        $elements.openBasePopup.magnificPopup({
            type: 'inline'
        });
    };

    var initPopup = function () {
        basePopup();
        preparedPopup();
    };

    var test = function () {
        return $elements.openBasePopup.length ? true : false;
    };

    var init = function () {
        setElements();

        if (test()) {
            loadJS();
        }
    };

    return {
        init: init
    };
}();

UL.register(PopUp);
